import React, { useContext as useContextCore } from 'react'
import { useLocalStorage } from 'react-use'
import type { Task } from '@ztechapps/common.contract'
import { TaskViewMode } from '@ztechapps/task.common'

type EmbeddedTaskViewContextType = {
  viewMode: TaskViewMode
  setViewMode: (mode: TaskViewMode) => void
  tasks: Task[]
  loading: boolean
}

const context = React.createContext<EmbeddedTaskViewContextType>({} as EmbeddedTaskViewContextType)

type EmbeddedTaskViewProviderProps = {
  children: React.ReactNode
  tasks: Task[]
  loading: boolean
  storageKey: string
}

export const EmbeddedTaskViewProvider = ({ children, tasks, loading, storageKey }: EmbeddedTaskViewProviderProps) => {
  const [viewMode, setViewMode] = useLocalStorage<TaskViewMode>(storageKey, TaskViewMode.List)

  return (
    <context.Provider value={{ viewMode: viewMode ?? TaskViewMode.List, setViewMode, tasks, loading }}>
      {children}
    </context.Provider>
  )
}

export const useEmbeddedTaskViewContext = () => useContextCore(context)
